var a = {};
export {
  a as __exports
};
//# sourceMappingURL=index.es320.js.map
